module.exports = __webpack_public_path__ + "static/media/usa-anli6.587bea79.jpg";